import { render, staticRenderFns } from "./DeliveryAuthorization.vue?vue&type=template&id=3c6d7ae2&scoped=true&lang=pug&"
import script from "./DeliveryAuthorization.vue?vue&type=script&lang=js&"
export * from "./DeliveryAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAuthorization.vue?vue&type=style&index=0&id=3c6d7ae2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d7ae2",
  null
  
)

export default component.exports